var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgLinkAirportLocations = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 25,
  height: 25,
  fill: "none"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  stroke: "#888",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1.25,
  d: "M22.495 6.025a2.84 2.84 0 1 0-4.017-4.017l-4.469 4.47a2.84 2.84 0 1 0 4.017 4.015zM10.494 18.025a2.84 2.84 0 1 0-4.017-4.017l-4.469 4.47a2.84 2.84 0 0 0 4.017 4.015zM16.004 8.491l-7 7"
})));
export default SvgLinkAirportLocations;